__turbopack_context__.v({
  "background": "NameInscriptionContent-module__Q90WlG__background",
  "content": "NameInscriptionContent-module__Q90WlG__content",
  "contentContainer": "NameInscriptionContent-module__Q90WlG__contentContainer",
  "root": "NameInscriptionContent-module__Q90WlG__root",
});
